var items = {
  "block.minecraft.air": "kon",
  "block.minecraft.stone": "kiwen",
  "block.minecraft.granite": "kiwen loje",
  "block.minecraft.polished_granite": "kiwen loje pi selo pona",
  "block.minecraft.diorite": "kiwen walo pimeja",
  "block.minecraft.polished_diorite": "kiwen walo pimeja pi selo pona",
  "block.minecraft.andesite": "kiwen pimeja walo",
  "block.minecraft.polished_andesite": "kiwen pimeja walo pi selo pona",
  "block.minecraft.grass_block": "ma kasi",
  "block.minecraft.dirt": "ma",
  "block.minecraft.coarse_dirt": "ma pi kiwen lili",
  "block.minecraft.podzol": "ma kule",
  "block.minecraft.crimson_nylium": "kiwen selo pi soko loje",
  "block.minecraft.warped_nylium": "kiwen selo pi soko laso",
  "block.minecraft.cobblestone": "kiwen nena",
  "block.minecraft.oak_planks": "kiwen kipisi pi kasi kiwen",
  "block.minecraft.spruce_planks": "kiwen kasi lete kipisi",
  "block.minecraft.birch_planks": "kiwen kasi walo kipisi",
  "block.minecraft.jungle_planks": "kiwen kasi loje kipisi",
  "block.minecraft.acacia_planks": "kiwen kasi kipisi pi loje jelo",
  "block.minecraft.dark_oak_planks": "kiwen kasi pimeja kipisi",
  "block.minecraft.crimson_planks": "kiwen kipisi pi soko loje",
  "block.minecraft.warped_planks": "kiwen kipisi pi soko laso",
  "block.minecraft.oak_sapling": "kasi kili sin",
  "block.minecraft.spruce_sapling": "kasi lete sin",
  "block.minecraft.birch_sapling": "kasi walo sin",
  "block.minecraft.jungle_sapling": "kasi suli sin",
  "block.minecraft.acacia_sapling": "kasi seli sin",
  "block.minecraft.dark_oak_sapling": "kasi pimeja sin",
  "block.minecraft.bedrock": "kiwen pi pakala ala",
  "block.minecraft.sand": "ko",
  "block.minecraft.red_sand": "ko loje",
  "block.minecraft.gravel": "kiwen lili mute",
  "block.minecraft.gold_ore": "kiwen jelo lon insa kiwen",
  "block.minecraft.iron_ore": "kiwen walo lon insa kiwen",
  "block.minecraft.coal_ore": "ko pimeja lon insa kiwen",
  "block.minecraft.nether_gold_ore": "kiwen jelo lon insa kiwen pi ma seli",
  "block.minecraft.oak_log": "sijelo pi kasi kili",
  "block.minecraft.spruce_log": "sijelo pi kasi lete",
  "block.minecraft.birch_log": "sijelo pi kasi walo",
  "block.minecraft.jungle_log": "sijelo pi kasi suli",
  "block.minecraft.acacia_log": "sijelo pi kasi seli",
  "block.minecraft.dark_oak_log": "sijelo pi kasi pimeja",
  "block.minecraft.crimson_stem": "sijelo pi soko loje",
  "block.minecraft.warped_stem": "sijelo pi soko laso",
  "block.minecraft.stripped_oak_log": "sijelo pi kasi kili pi selo weka",
  "block.minecraft.stripped_spruce_log": "sijelo pi kasi lete pi selo weka",
  "block.minecraft.stripped_birch_log": "sijelo pi kasi walo pi selo weka",
  "block.minecraft.stripped_jungle_log": "sijelo pi kasi suli pi selo weka",
  "block.minecraft.stripped_acacia_log": "sijelo pi kasi seli pi selo weka",
  "block.minecraft.stripped_dark_oak_log": "sijelo pi kasi pimeja pi selo weka",
  "block.minecraft.stripped_crimson_stem": "sijelo pi soko loje pi selo weka",
  "block.minecraft.stripped_warped_stem": "sijelo pi soko laso pi selo weka",
  "block.minecraft.stripped_oak_wood": "sijelo selo pi kasi kili pi selo weka",
  "block.minecraft.stripped_spruce_wood": "sijelo selo pi kasi lete pi selo weka",
  "block.minecraft.stripped_birch_wood": "sijelo selo pi kasi walo pi selo weka",
  "block.minecraft.stripped_jungle_wood": "sijelo selo pi kasi suli pi selo weka",
  "block.minecraft.stripped_acacia_wood": "sijelo selo pi kasi seli pi selo weka",
  "block.minecraft.stripped_dark_oak_wood": "sijelo selo pi kasi pimeja pi selo weka",
  "block.minecraft.stripped_crimson_hyphae": "sijelo selo pi soko loje pi selo weka",
  "block.minecraft.stripped_warped_hyphae": "sijelo selo pi soko laso pi selo weka",
  "block.minecraft.oak_wood": "sijelo selo pi kasi kili",
  "block.minecraft.spruce_wood": "sijelo selo pi kasi lete",
  "block.minecraft.birch_wood": "sijelo selo pi kasi walo",
  "block.minecraft.jungle_wood": "sijelo selo pi kasi suli",
  "block.minecraft.acacia_wood": "sijelo selo pi kasi seli",
  "block.minecraft.dark_oak_wood": "sijelo selo pi kasi pimeja",
  "block.minecraft.crimson_hyphae": "sijelo selo pi soko loje",
  "block.minecraft.warped_hyphae": "sijelo selo pi soko laso",
  "block.minecraft.oak_leaves": "lipu pi kasi kili",
  "block.minecraft.spruce_leaves": "lipu pi kasi lete",
  "block.minecraft.birch_leaves": "lipu pi kasi walo",
  "block.minecraft.jungle_leaves": "lipu pi kasi suli",
  "block.minecraft.acacia_leaves": "lipu pi kasi seli",
  "block.minecraft.dark_oak_leaves": "lipu pi kasi pimeja",
  "block.minecraft.sponge": "ko pi weka telo",
  "block.minecraft.wet_sponge": "ko telo",
  "block.minecraft.glass": "kiwen lukin",
  "block.minecraft.lapis_ore": "kiwen pi laso telo lon insa kiwen",
  "block.minecraft.lapis_block": "leko pi kiwen pi laso telo",
  "block.minecraft.dispenser": "poki pi pana wawa",
  "block.minecraft.sandstone": "kiwen ko",
  "block.minecraft.chiseled_sandstone": "kiwen ko sitelen",
  "block.minecraft.cut_sandstone": "kiwen ko kipisi",
  "block.minecraft.note_block": "leko kalama",
  "block.minecraft.powered_rail": "nasin palisa wawa",
  "block.minecraft.detector_rail": "nasin palisa lukin",
  "block.minecraft.sticky_piston": "ilo tawa ko",
  "block.minecraft.cobweb": "linja pipi",
  "block.minecraft.grass": "kasi anpa",
  "block.minecraft.fern": "kasi pi lipu waso",
  "block.minecraft.dead_bush": "kasi moli",
  "block.minecraft.seagrass": "kasi telo",
  "block.minecraft.sea_pickle": "kili telo",
  "block.minecraft.piston": "ilo tawa",
  "block.minecraft.white_wool": "len walo",
  "block.minecraft.orange_wool": "len pi loje jelo",
  "block.minecraft.magenta_wool": "len pi loje laso",
  "block.minecraft.light_blue_wool": "len pi laso sewi",
  "block.minecraft.yellow_wool": "len jelo",
  "block.minecraft.lime_wool": "len pi laso jelo",
  "block.minecraft.pink_wool": "len pi loje walo",
  "block.minecraft.gray_wool": "len pi pimeja walo",
  "block.minecraft.light_gray_wool": "len pi walo pimeja",
  "block.minecraft.cyan_wool": "len laso",
  "block.minecraft.purple_wool": "len pi laso loje",
  "block.minecraft.blue_wool": "len pi laso telo",
  "block.minecraft.brown_wool": "len pi kule ma",
  "block.minecraft.green_wool": "len pi laso kasi",
  "block.minecraft.red_wool": "len loje",
  "block.minecraft.black_wool": "len pimeja",
  "block.minecraft.dandelion": "kasi jelo",
  "block.minecraft.poppy": "kasi loje",
  "block.minecraft.blue_orchid": "kasi pi laso sewi",
  "block.minecraft.allium": "kasi pi laso loje",
  "block.minecraft.azure_bluet": "kasi walo lili",
  "block.minecraft.red_tulip": "kasi uta loje",
  "block.minecraft.orange_tulip": "kasi uta pi loje jelo",
  "block.minecraft.white_tulip": "kasi uta walo",
  "block.minecraft.pink_tulip": "kasi uta pi loje walo",
  "block.minecraft.oxeye_daisy": "kasi oko",
  "block.minecraft.cornflower": "kasi laso",
  "block.minecraft.lily_of_the_valley": "kasi lili suwi",
  "block.minecraft.wither_rose": "kasi pi moli pimeja",
  "block.minecraft.brown_mushroom": "soko pi kule ma",
  "block.minecraft.red_mushroom": "soko loje walo",
  "block.minecraft.crimson_fungus": "soko loje seli",
  "block.minecraft.warped_fungus": "soko laso",
  "block.minecraft.crimson_roots": "noka kasi loje",
  "block.minecraft.warped_roots": "noka kasi laso",
  "block.minecraft.nether_sprouts": "kasi lili pi ma seli",
  "block.minecraft.weeping_vines": "kasi linja loje",
  "block.minecraft.twisting_vines": "kasi linja laso",
  "block.minecraft.sugar_cane": "kasi suwi",
  "block.minecraft.kelp": "kasi linja telo",
  "block.minecraft.bamboo": "kasi palisa",
  "block.minecraft.gold_block": "leko pi kiwen jelo",
  "block.minecraft.iron_block": "leko pi kiwen walo",
  "block.minecraft.oak_slab": "supa pi kasi kiwen",
  "block.minecraft.spruce_slab": "supa pi kasi lete",
  "block.minecraft.birch_slab": "supa pi kasi walo",
  "block.minecraft.jungle_slab": "supa pi kasi loje",
  "block.minecraft.acacia_slab": "supa kasi pi loje jelo",
  "block.minecraft.dark_oak_slab": "supa pi kasi pimeja",
  "block.minecraft.crimson_slab": "supa pi soko loje",
  "block.minecraft.warped_slab": "supa pi soko laso",
  "block.minecraft.stone_slab": "supa kiwen",
  "block.minecraft.smooth_stone_slab": "supa kiwen pi selo pona",
  "block.minecraft.sandstone_slab": "supa pi kiwen ko",
  "block.minecraft.cut_sandstone_slab": "supa pi kiwen ko kipisi",
  "block.minecraft.petrified_oak_slab": "supa pi kasi kiwen moli",
  "block.minecraft.cobblestone_slab": "supa pi kiwen nena",
  "block.minecraft.brick_slab": "supa pi kiwen leko loje",
  "block.minecraft.stone_brick_slab": "supa pi kiwen leko",
  "block.minecraft.nether_brick_slab": "supa pi ma seli",
  "block.minecraft.quartz_slab": "supa pi kiwen walo",
  "block.minecraft.red_sandstone_slab": "supa pi kiwen ko loje",
  "block.minecraft.cut_red_sandstone_slab": "supa pi kiwen ko loje kipisi",
  "block.minecraft.purpur_slab": "supa kule pi ma pini",
  "block.minecraft.prismarine_slab": "supa pi kiwen telo",
  "block.minecraft.prismarine_brick_slab": "supa pi kiwen telo leko",
  "block.minecraft.dark_prismarine_slab": "supa pi kiwen telo pimeja",
  "block.minecraft.smooth_quartz": "kiwen walo suli pi selo pona",
  "block.minecraft.smooth_red_sandstone": "kiwen ko loje pi selo pona",
  "block.minecraft.smooth_sandstone": "kiwen ko pi selo pona",
  "block.minecraft.smooth_stone": "kiwen pi selo pona",
  "block.minecraft.bricks": "kiwen leko loje",
  "block.minecraft.tnt": "ilo pi seli pakala",
  "block.minecraft.bookshelf": "poki lipu",
  "block.minecraft.mossy_cobblestone": "kiwen nena kasi",
  "block.minecraft.obsidian": "kiwen pimeja wawa",
  "block.minecraft.torch": "palisa suno",
  "block.minecraft.end_rod": "palisa sewi",
  "block.minecraft.chorus_plant": "kasi nasa",
  "block.minecraft.chorus_flower": "lawa pi kasi nasa",
  "block.minecraft.purpur_block": "kiwen kule pi ma pini",
  "block.minecraft.purpur_pillar": "kiwen kule palisa pi ma pini",
  "block.minecraft.purpur_stairs": "leko sewi kule pi ma pini",
  "block.minecraft.spawner": "ilo kama",
  "block.minecraft.oak_stairs": "leko sewi pi kasi kiwen",
  "block.minecraft.chest": "poki",
  "block.minecraft.diamond_ore": "kiwen laso lon insa kiwen",
  "block.minecraft.diamond_block": "leko pi kiwen laso",
  "block.minecraft.crafting_table": "supa pali",
  "block.minecraft.farmland": "ma kasi",
  "block.minecraft.furnace": "poki seli",
  "block.minecraft.ladder": "nasin palisa sewi",
  "block.minecraft.rail": "nasin palisa",
  "block.minecraft.cobblestone_stairs": "leko sewi pi kiwen nena",
  "block.minecraft.lever": "palisa ilo",
  "block.minecraft.stone_pressure_plate": "supa noka kiwen",
  "block.minecraft.oak_pressure_plate": "supa noka pi kasi kiwen",
  "block.minecraft.spruce_pressure_plate": "supa noka pi kasi lete",
  "block.minecraft.birch_pressure_plate": "supa noka pi kasi walo",
  "block.minecraft.jungle_pressure_plate": "supa noka pi kasi loje",
  "block.minecraft.acacia_pressure_plate": "supa noka kasi pi loje jelo",
  "block.minecraft.dark_oak_pressure_plate": "supa noka pi kasi pimeja",
  "block.minecraft.crimson_pressure_plate": "supa noka pi soko loje",
  "block.minecraft.warped_pressure_plate": "supa noka pi soko laso",
  "block.minecraft.polished_blackstone_pressure_plate": "supa noka pi kiwen pimeja pi selo pona",
  "block.minecraft.redstone_ore": "ko wawa lon insa kiwen",
  "block.minecraft.redstone_torch": "palisa suno loje",
  "block.minecraft.snow": "ko lete",
  "block.minecraft.ice": "telo kiwen",
  "block.minecraft.snow_block": "ko lete suli",
  "block.minecraft.cactus": "kasi kipisi",
  "block.minecraft.clay": "ma ko",
  "block.minecraft.jukebox": "ilo pi kalama musi",
  "block.minecraft.oak_fence": "sinpin palisa pi kasi kiwen",
  "block.minecraft.spruce_fence": "sinpin palisa pi kasi lete",
  "block.minecraft.birch_fence": "sinpin palisa pi kasi walo",
  "block.minecraft.jungle_fence": "sinpin palisa pi kasi loje",
  "block.minecraft.acacia_fence": "sinpin palisa kasi pi loje jelo",
  "block.minecraft.dark_oak_fence": "sinpin palisa pi kasi pimeja",
  "block.minecraft.crimson_fence": "sinpin palisa pi soko loje",
  "block.minecraft.warped_fence": "sinpin palisa pi soko laso",
  "block.minecraft.pumpkin": "kili suli jelo",
  "block.minecraft.carved_pumpkin": "kili suli monsuta",
  "block.minecraft.netherrack": "kiwen pi ma seli",
  "block.minecraft.soul_sand": "ko kon",
  "block.minecraft.soul_soil": "ma kon",
  "block.minecraft.basalt": "kiwen pi seli lete",
  "block.minecraft.polished_basalt": "kiwen palisa pi seli lete",
  "block.minecraft.soul_torch": "palisa suno kon",
  "block.minecraft.glowstone": "kiwen suno",
  "block.minecraft.jack_o_lantern": "kili suli suno",
  "block.minecraft.oak_trapdoor": "lupa anpa pi kasi kiwen",
  "block.minecraft.spruce_trapdoor": "lupa anpa pi kasi lete",
  "block.minecraft.birch_trapdoor": "lupa anpa pi kasi walo",
  "block.minecraft.jungle_trapdoor": "lupa anpa pi kasi loje",
  "block.minecraft.acacia_trapdoor": "lupa anpa kasi pi loje jelo",
  "block.minecraft.dark_oak_trapdoor": "lupa anpa pi kasi pimeja",
  "block.minecraft.crimson_trapdoor": "lupa anpa pi soko loje",
  "block.minecraft.warped_trapdoor": "lupa anpa pi soko laso",
  "block.minecraft.infested_stone": "kiwen pipi",
  "block.minecraft.infested_cobblestone": "kiwen nena pipi",
  "block.minecraft.infested_stone_bricks": "kiwen leko pipi",
  "block.minecraft.infested_mossy_stone_bricks": "kiwen leko kasi pipi",
  "block.minecraft.infested_cracked_stone_bricks": "kiwen leko pakala pipi",
  "block.minecraft.infested_chiseled_stone_bricks": "kiwen leko sitelen pipi",
  "block.minecraft.stone_bricks": "kiwen leko",
  "block.minecraft.mossy_stone_bricks": "kiwen leko kasi",
  "block.minecraft.cracked_stone_bricks": "kiwen leko pakala",
  "block.minecraft.chiseled_stone_bricks": "kiwen leko sitelen",
  "block.minecraft.brown_mushroom_block": "soko suli pi kule ma",
  "block.minecraft.red_mushroom_block": "soko suli loje walo",
  "block.minecraft.mushroom_stem": "sijelo soko",
  "block.minecraft.iron_bars": "sinpin palisa pi kiwen walo",
  "block.minecraft.chain": "linja kiwen",
  "block.minecraft.glass_pane": "sinpin lukin",
  "block.minecraft.melon": "kili suli laso",
  "block.minecraft.vine": "kasi linja",
  "block.minecraft.oak_fence_gate": "sinpin tawa pi kasi kiwen",
  "block.minecraft.spruce_fence_gate": "sinpin tawa pi kasi lete",
  "block.minecraft.birch_fence_gate": "sinpin tawa pi kasi walo",
  "block.minecraft.jungle_fence_gate": "sinpin tawa pi kasi loje",
  "block.minecraft.acacia_fence_gate": "sinpin tawa kasi pi loje jelo",
  "block.minecraft.dark_oak_fence_gate": "sinpin tawa pi kasi pimeja",
  "block.minecraft.crimson_fence_gate": "sinpin tawa pi soko loje",
  "block.minecraft.warped_fence_gate": "sinpin tawa pi soko laso",
  "block.minecraft.brick_stairs": "leko sewi pi kiwen leko loje",
  "block.minecraft.stone_brick_stairs": "leko sewi pi kiwen leko",
  "block.minecraft.mycelium": "ma soko",
  "block.minecraft.lily_pad": "kasi telo sike",
  "block.minecraft.nether_bricks": "kiwen leko seli",
  "block.minecraft.cracked_nether_bricks": "kiwen leko pakala seli",
  "block.minecraft.chiseled_nether_bricks": "leko seli sitelen",
  "block.minecraft.nether_brick_fence": "sinpin palisa pi ma seli",
  "block.minecraft.nether_brick_stairs": "leko sewi pi ma seli",
  "block.minecraft.enchanting_table": "supa wawa",
  "block.minecraft.end_portal_frame": "selo lupa pi ma pini",
  "block.minecraft.end_stone": "kiwen pi ma pini",
  "block.minecraft.end_stone_bricks": "kiwen leko pi ma pini",
  "block.minecraft.dragon_egg": "sike mama pi akesi pini",
  "block.minecraft.redstone_lamp": "suno wawa",
  "block.minecraft.sandstone_stairs": "leko sewi pi kiwen ko",
  "block.minecraft.emerald_ore": "kiwen esun lon insa kiwen",
  "block.minecraft.ender_chest": "poki nasa",
  "block.minecraft.tripwire_hook": "ilo pi linja noka",
  "block.minecraft.emerald_block": "leko pi kiwen esun",
  "block.minecraft.spruce_stairs": "leko sewi pi kasi lete",
  "block.minecraft.birch_stairs": "leko sewi walo",
  "block.minecraft.jungle_stairs": "leko sewi loje walo",
  "block.minecraft.crimson_stairs": "leko sewi pi soko loje",
  "block.minecraft.warped_stairs": "leko sewi pi soko laso",
  "block.minecraft.command_block": "ilo pi toki wawa",
  "block.minecraft.beacon": "ilo wawa",
  "block.minecraft.cobblestone_wall": "sinpin pi kiwen nena",
  "block.minecraft.mossy_cobblestone_wall": "sinpin pi kiwen nena kasi",
  "block.minecraft.brick_wall": "sinpin pi kiwen leko loje",
  "block.minecraft.prismarine_wall": "sinpin pi kiwen telo",
  "block.minecraft.red_sandstone_wall": "sinpin pi kiwen ko loje",
  "block.minecraft.mossy_stone_brick_wall": "sinpin pi kiwen leko kasi",
  "block.minecraft.granite_wall": "sinpin pi kiwen loje",
  "block.minecraft.stone_brick_wall": "sinpin pi kiwen leko",
  "block.minecraft.nether_brick_wall": "sinpin pi ma seli",
  "block.minecraft.andesite_wall": "sinpin pi kiwen pimeja walo",
  "block.minecraft.red_nether_brick_wall": "sinpin loje pi ma seli",
  "block.minecraft.sandstone_wall": "sinpin pi kiwen ko",
  "block.minecraft.end_stone_brick_wall": "sinpin kiwen pi ma pini",
  "block.minecraft.diorite_wall": "sinpin pi kiwen walo pimeja",
  "block.minecraft.blackstone_wall": "sinpin kiwen pimeja",
  "block.minecraft.polished_blackstone_wall": "sinpin pi kiwen pimeja pi selo pona",
  "block.minecraft.polished_blackstone_brick_wall": "sinpin pi kiwen pimeja leko",
  "block.minecraft.stone_button": "nena ilo kiwen",
  "block.minecraft.oak_button": "nena ilo pi kasi kiwen",
  "block.minecraft.spruce_button": "nena ilo pi kasi lete",
  "block.minecraft.birch_button": "nena ilo pi kasi walo",
  "block.minecraft.jungle_button": "nena ilo pi kasi loje",
  "block.minecraft.acacia_button": "nena ilo kasi pi loje jelo",
  "block.minecraft.dark_oak_button": "nena ilo pi kasi pimeja",
  "block.minecraft.crimson_button": "nena ilo pi soko loje",
  "block.minecraft.warped_button": "nena ilo pi soko laso",
  "block.minecraft.polished_blackstone_button": "nena ilo pi kiwen pimeja pi selo pona",
  "block.minecraft.anvil": "supa pona",
  "block.minecraft.chipped_anvil": "supa pona pi pakala lili",
  "block.minecraft.damaged_anvil": "supa pona pakala",
  "block.minecraft.trapped_chest": "poki lukin",
  "block.minecraft.light_weighted_pressure_plate": "supa noka pi kiwen jelo",
  "block.minecraft.heavy_weighted_pressure_plate": "supa noka pi kiwen walo",
  "block.minecraft.daylight_detector": "ilo lukin pi suno sewi",
  "block.minecraft.redstone_block": "leko pi ko wawa",
  "block.minecraft.nether_quartz_ore": "kiwen walo lon insa kiwen pi ma seli",
  "block.minecraft.hopper": "poki pi tawa ijo",
  "block.minecraft.chiseled_quartz_block": "kiwen walo sitelen",
  "block.minecraft.quartz_block": "leko pi kiwen walo pi ma seli",
  "block.minecraft.quartz_bricks": "kiwen walo leko",
  "block.minecraft.quartz_pillar": "kiwen walo palisa",
  "block.minecraft.quartz_stairs": "leko sewi pi kiwen walo",
  "block.minecraft.activator_rail": "nasin palisa weka",
  "block.minecraft.dropper": "poki pana",
  "block.minecraft.white_terracotta": "ma kiwen walo",
  "block.minecraft.orange_terracotta": "ma kiwen pi loje jelo",
  "block.minecraft.magenta_terracotta": "ma kiwen pi loje laso",
  "block.minecraft.light_blue_terracotta": "ma kiwen pi laso sewi",
  "block.minecraft.yellow_terracotta": "ma kiwen jelo",
  "block.minecraft.lime_terracotta": "ma kiwen pi laso jelo",
  "block.minecraft.pink_terracotta": "ma kiwen pi loje walo",
  "block.minecraft.gray_terracotta": "ma kiwen pi pimeja walo",
  "block.minecraft.light_gray_terracotta": "ma kiwen pi walo pimeja",
  "block.minecraft.cyan_terracotta": "ma kiwen laso",
  "block.minecraft.purple_terracotta": "ma kiwen pi laso loje",
  "block.minecraft.blue_terracotta": "ma kiwen pi laso telo",
  "block.minecraft.brown_terracotta": "ma kiwen pi kule ma",
  "block.minecraft.green_terracotta": "ma kiwen pi laso kasi",
  "block.minecraft.red_terracotta": "ma kiwen loje",
  "block.minecraft.black_terracotta": "ma kiwen pimeja",
  "block.minecraft.barrier": "sinpin kon",
  "block.minecraft.iron_trapdoor": "lupa anpa pi kiwen walo",
  "block.minecraft.hay_block": "kulupu pan",
  "block.minecraft.white_carpet": "len anpa walo",
  "block.minecraft.orange_carpet": "len anpa pi loje jelo",
  "block.minecraft.magenta_carpet": "len anpa pi loje laso",
  "block.minecraft.light_blue_carpet": "len anpa pi laso sewi",
  "block.minecraft.yellow_carpet": "len anpa jelo",
  "block.minecraft.lime_carpet": "len anpa pi laso jelo",
  "block.minecraft.pink_carpet": "len anpa pi loje walo",
  "block.minecraft.gray_carpet": "len anpa pi pimeja walo",
  "block.minecraft.light_gray_carpet": "len anpa pi walo pimeja",
  "block.minecraft.cyan_carpet": "len anpa laso",
  "block.minecraft.purple_carpet": "len anpa pi laso loje",
  "block.minecraft.blue_carpet": "len anpa pi laso telo",
  "block.minecraft.brown_carpet": "len anpa pi kule ma",
  "block.minecraft.green_carpet": "len anpa pi laso kasi",
  "block.minecraft.red_carpet": "len anpa loje",
  "block.minecraft.black_carpet": "len anpa pimeja",
  "block.minecraft.terracotta": "ma kiwen",
  "block.minecraft.coal_block": "leko pi ko pimeja",
  "block.minecraft.packed_ice": "telo kiwen kiwen",
  "block.minecraft.acacia_stairs": "leko sewi pi loje jelo",
  "block.minecraft.dark_oak_stairs": "leko sewi pi kasi pimeja",
  "block.minecraft.slime_block": "ko monsuta suli",
  "block.minecraft.grass_path": "ma nasin",
  "block.minecraft.sunflower": "kasi suno",
  "block.minecraft.lilac": "kasi suli pi loje laso",
  "block.minecraft.rose_bush": "kasi loje suwi",
  "block.minecraft.peony": "kasi suli pi loje walo",
  "block.minecraft.tall_grass": "kasi anpa suli",
  "block.minecraft.large_fern": "kasi suli pi lipu waso",
  "block.minecraft.white_stained_glass": "kiwen lukin walo",
  "block.minecraft.orange_stained_glass": "kiwen lukin pi loje jelo",
  "block.minecraft.magenta_stained_glass": "kiwen lukin pi loje laso",
  "block.minecraft.light_blue_stained_glass": "kiwen lukin pi laso sewi",
  "block.minecraft.yellow_stained_glass": "kiwen lukin jelo",
  "block.minecraft.lime_stained_glass": "kiwen lukin pi laso jelo",
  "block.minecraft.pink_stained_glass": "kiwen lukin pi loje walo",
  "block.minecraft.gray_stained_glass": "kiwen lukin pi pimeja walo",
  "block.minecraft.light_gray_stained_glass": "kiwen lukin pi walo pimeja",
  "block.minecraft.cyan_stained_glass": "kiwen lukin laso",
  "block.minecraft.purple_stained_glass": "kiwen lukin pi laso loje",
  "block.minecraft.blue_stained_glass": "kiwen lukin pi laso telo",
  "block.minecraft.brown_stained_glass": "kiwen lukin pi kule ma",
  "block.minecraft.green_stained_glass": "kiwen lukin pi laso kasi",
  "block.minecraft.red_stained_glass": "kiwen lukin loje",
  "block.minecraft.black_stained_glass": "kiwen lukin pimeja",
  "block.minecraft.white_stained_glass_pane": "sinpin lukin walo",
  "block.minecraft.orange_stained_glass_pane": "sinpin lukin pi loje jelo",
  "block.minecraft.magenta_stained_glass_pane": "sinpin lukin pi loje laso",
  "block.minecraft.light_blue_stained_glass_pane": "sinpin lukin pi laso sewi",
  "block.minecraft.yellow_stained_glass_pane": "sinpin lukin jelo",
  "block.minecraft.lime_stained_glass_pane": "sinpin lukin pi laso jelo",
  "block.minecraft.pink_stained_glass_pane": "sinpin lukin pi loje walo",
  "block.minecraft.gray_stained_glass_pane": "sinpin lukin pi pimeja walo",
  "block.minecraft.light_gray_stained_glass_pane": "sinpin lukin pi walo pimeja",
  "block.minecraft.cyan_stained_glass_pane": "sinpin lukin laso",
  "block.minecraft.purple_stained_glass_pane": "sinpin lukin pi laso loje",
  "block.minecraft.blue_stained_glass_pane": "sinpin lukin pi laso telo",
  "block.minecraft.brown_stained_glass_pane": "sinpin lukin pi kule ma",
  "block.minecraft.green_stained_glass_pane": "sinpin lukin pi laso kasi",
  "block.minecraft.red_stained_glass_pane": "sinpin lukin loje",
  "block.minecraft.black_stained_glass_pane": "sinpin lukin pimeja",
  "block.minecraft.prismarine": "kiwen telo",
  "block.minecraft.prismarine_bricks": "kiwen telo leko",
  "block.minecraft.dark_prismarine": "kiwen telo pimeja",
  "block.minecraft.prismarine_stairs": "leko sewi pi kiwen kala",
  "block.minecraft.prismarine_brick_stairs": "leko sewi pi kiwen kala kipisi",
  "block.minecraft.dark_prismarine_stairs": "leko sewi pi kiwen kala pimeja",
  "block.minecraft.sea_lantern": "suno telo",
  "block.minecraft.red_sandstone": "kiwen ko loje",
  "block.minecraft.chiseled_red_sandstone": "kiwen ko loje sitelen",
  "block.minecraft.cut_red_sandstone": "kiwen ko loje kipisi",
  "block.minecraft.red_sandstone_stairs": "leko sewi pi kiwen ko loje",
  "block.minecraft.repeating_command_block": "ilo pi toki wawa lon sike",
  "block.minecraft.chain_command_block": "ilo pi toki wawa lon linja",
  "block.minecraft.magma_block": "kiwen seli",
  "block.minecraft.nether_wart_block": "soko wawa suli",
  "block.minecraft.warped_wart_block": "soko laso suli",
  "block.minecraft.red_nether_bricks": "kiwen leko loje seli",
  "block.minecraft.bone_block": "kiwen sijelo suli",
  "block.minecraft.structure_void": "ala pali",
  "block.minecraft.observer": "ilo lukin wawa",
  "block.minecraft.shulker_box": "poki monsuta",
  "block.minecraft.white_shulker_box": "poki monsuta walo",
  "block.minecraft.orange_shulker_box": "poki monsuta pi loje jelo",
  "block.minecraft.magenta_shulker_box": "poki monsuta pi loje laso",
  "block.minecraft.light_blue_shulker_box": "poki monsuta pi laso sewi",
  "block.minecraft.yellow_shulker_box": "poki monsuta jelo",
  "block.minecraft.lime_shulker_box": "poki monsuta pi laso jelo",
  "block.minecraft.pink_shulker_box": "poki monsuta pi loje walo",
  "block.minecraft.gray_shulker_box": "poki monsuta pi pimeja walo",
  "block.minecraft.light_gray_shulker_box": "poki monsuta pi walo pimeja",
  "block.minecraft.cyan_shulker_box": "poki monsuta laso",
  "block.minecraft.purple_shulker_box": "poki monsuta pi laso loje",
  "block.minecraft.blue_shulker_box": "poki monsuta pi laso telo",
  "block.minecraft.brown_shulker_box": "poki monsuta pi kule ma",
  "block.minecraft.green_shulker_box": "poki monsuta pi laso kasi",
  "block.minecraft.red_shulker_box": "poki monsuta loje",
  "block.minecraft.black_shulker_box": "poki monsuta pimeja",
  "block.minecraft.white_glazed_terracotta": "kiwen namako walo",
  "block.minecraft.orange_glazed_terracotta": "kiwen namako pi loje jelo",
  "block.minecraft.magenta_glazed_terracotta": "kiwen namako pi loje laso",
  "block.minecraft.light_blue_glazed_terracotta": "kiwen namako pi laso sewi",
  "block.minecraft.yellow_glazed_terracotta": "kiwen namako jelo",
  "block.minecraft.lime_glazed_terracotta": "kiwen namako pi laso jelo",
  "block.minecraft.pink_glazed_terracotta": "kiwen namako pi loje walo",
  "block.minecraft.gray_glazed_terracotta": "kiwen namako pi pimeja walo",
  "block.minecraft.light_gray_glazed_terracotta": "kiwen namako pi walo pimeja",
  "block.minecraft.cyan_glazed_terracotta": "kiwen namako laso",
  "block.minecraft.purple_glazed_terracotta": "kiwen namako pi laso loje",
  "block.minecraft.blue_glazed_terracotta": "kiwen namako pi laso telo",
  "block.minecraft.brown_glazed_terracotta": "kiwen namako pi kule ma",
  "block.minecraft.green_glazed_terracotta": "kiwen namako pi laso kasi",
  "block.minecraft.red_glazed_terracotta": "kiwen namako loje",
  "block.minecraft.black_glazed_terracotta": "kiwen namako pimeja",
  "block.minecraft.white_concrete": "kiwen kule walo",
  "block.minecraft.orange_concrete": "kiwen kule pi loje jelo",
  "block.minecraft.magenta_concrete": "kiwen kule pi loje laso",
  "block.minecraft.light_blue_concrete": "kiwen kule pi laso sewi",
  "block.minecraft.yellow_concrete": "kiwen kule jelo",
  "block.minecraft.lime_concrete": "kiwen kule pi laso jelo",
  "block.minecraft.pink_concrete": "kiwen kule pi loje walo",
  "block.minecraft.gray_concrete": "kiwen kule pi pimeja walo",
  "block.minecraft.light_gray_concrete": "kiwen kule pi walo pimeja",
  "block.minecraft.cyan_concrete": "kiwen kule laso",
  "block.minecraft.purple_concrete": "kiwen kule pi laso loje",
  "block.minecraft.blue_concrete": "kiwen kule pi laso telo",
  "block.minecraft.brown_concrete": "kiwen kule pi kule ma",
  "block.minecraft.green_concrete": "kiwen kule pi laso kasi",
  "block.minecraft.red_concrete": "kiwen kule loje",
  "block.minecraft.black_concrete": "kiwen kule pimeja",
  "block.minecraft.white_concrete_powder": "ko kule walo",
  "block.minecraft.orange_concrete_powder": "ko kule pi loje jelo",
  "block.minecraft.magenta_concrete_powder": "ko kule pi loje laso",
  "block.minecraft.light_blue_concrete_powder": "ko kule pi laso sewi",
  "block.minecraft.yellow_concrete_powder": "ko kule jelo",
  "block.minecraft.lime_concrete_powder": "ko kule pi laso jelo",
  "block.minecraft.pink_concrete_powder": "ko kule pi loje walo",
  "block.minecraft.gray_concrete_powder": "ko kule pi pimeja walo",
  "block.minecraft.light_gray_concrete_powder": "ko kule pi walo pimeja",
  "block.minecraft.cyan_concrete_powder": "ko kule laso",
  "block.minecraft.purple_concrete_powder": "ko kule pi laso loje",
  "block.minecraft.blue_concrete_powder": "ko kule pi laso telo",
  "block.minecraft.brown_concrete_powder": "ko kule pi kule ma",
  "block.minecraft.green_concrete_powder": "ko kule pi laso kasi",
  "block.minecraft.red_concrete_powder": "ko kule loje",
  "block.minecraft.black_concrete_powder": "ko kule pimeja",
  "block.minecraft.turtle_egg": "sike mama pi akesi tomo",
  "block.minecraft.dead_tube_coral_block": "kiwen kala laso suli moli",
  "block.minecraft.dead_brain_coral_block": "kiwen kala suli moli pi loje walo",
  "block.minecraft.dead_bubble_coral_block": "kiwen kala suli moli pi laso loje",
  "block.minecraft.dead_fire_coral_block": "kiwen kala loje suli moli",
  "block.minecraft.dead_horn_coral_block": "kiwen kala jelo suli moli",
  "block.minecraft.tube_coral_block": "kiwen kala laso suli",
  "block.minecraft.brain_coral_block": "kiwen kala suli pi loje walo",
  "block.minecraft.bubble_coral_block": "kiwen kala suli pi laso loje",
  "block.minecraft.fire_coral_block": "kiwen kala loje suli",
  "block.minecraft.horn_coral_block": "kiwen kala jelo suli",
  "block.minecraft.tube_coral": "kiwen kala laso",
  "block.minecraft.brain_coral": "kiwen kala pi loje walo",
  "block.minecraft.bubble_coral": "kiwen kala pi laso loje",
  "block.minecraft.fire_coral": "kiwen kala loje",
  "block.minecraft.horn_coral": "kiwen kala jelo",
  "block.minecraft.dead_brain_coral": "kiwen kala moli pi loje walo",
  "block.minecraft.dead_bubble_coral": "kiwen kala moli pi laso loje",
  "block.minecraft.dead_fire_coral": "kiwen kala loje moli",
  "block.minecraft.dead_horn_coral": "kiwen kala jelo moli",
  "block.minecraft.dead_tube_coral": "kiwen kala laso moli",
  "block.minecraft.tube_coral_fan": "lipu pi kiwen kala laso",
  "block.minecraft.brain_coral_fan": "lipu pi kiwen kala pi loje walo",
  "block.minecraft.bubble_coral_fan": "lipu pi kiwen kala pi laso loje",
  "block.minecraft.fire_coral_fan": "lipu pi kiwen kala loje",
  "block.minecraft.horn_coral_fan": "lipu pi kiwen kala jelo",
  "block.minecraft.dead_tube_coral_fan": "lipu pi kiwen kala laso moli",
  "block.minecraft.dead_brain_coral_fan": "lipu pi kiwen kala moli pi loje walo",
  "block.minecraft.dead_bubble_coral_fan": "lipu pi kiwen kala moli pi laso loje",
  "block.minecraft.dead_fire_coral_fan": "lipu pi kiwen kala loje moli",
  "block.minecraft.dead_horn_coral_fan": "lipu pi kiwen kala jelo moli",
  "block.minecraft.blue_ice": "telo kiwen laso",
  "block.minecraft.conduit": "ilo wawa telo",
  "block.minecraft.polished_granite_stairs": "leko sewi pi kiwen loje pi selo pona",
  "block.minecraft.smooth_red_sandstone_stairs": "leko sewi pi kiwen ko loje pi selo pona",
  "block.minecraft.mossy_stone_brick_stairs": "leko sewi pi kiwen leko kasi",
  "block.minecraft.polished_diorite_stairs": "leko sewi pi kiwen walo pimeja pi selo pona",
  "block.minecraft.mossy_cobblestone_stairs": "leko sewi pi kiwen nena kasi",
  "block.minecraft.end_stone_brick_stairs": "leko sewi pi ma pini",
  "block.minecraft.stone_stairs": "leko sewi kiwen",
  "block.minecraft.smooth_sandstone_stairs": "leko sewi pi kiwen ko pi selo pona",
  "block.minecraft.smooth_quartz_stairs": "leko sewi pi kiwen walo pi selo pona",
  "block.minecraft.granite_stairs": "leko sewi pi kiwen loje",
  "block.minecraft.andesite_stairs": "leko sewi pi kiwen pimeja walo",
  "block.minecraft.red_nether_brick_stairs": "leko sewi loje pi ma seli",
  "block.minecraft.polished_andesite_stairs": "leko sewi pi kiwen pimeja walo pi selo pona",
  "block.minecraft.diorite_stairs": "leko sewi pi kiwen walo pimeja",
  "block.minecraft.polished_granite_slab": "supa pi kiwen loje pi selo pona",
  "block.minecraft.smooth_red_sandstone_slab": "supa pi kiwen ko loje pi selo pona",
  "block.minecraft.mossy_stone_brick_slab": "supa pi kiwen leko kasi",
  "block.minecraft.polished_diorite_slab": "supa pi kiwen walo pimeja pi selo pona",
  "block.minecraft.mossy_cobblestone_slab": "supa pi kiwen nena kasi",
  "block.minecraft.end_stone_brick_slab": "supa kiwen pi ma pini",
  "block.minecraft.smooth_sandstone_slab": "supa pi kiwen ko pi selo pona",
  "block.minecraft.smooth_quartz_slab": "supa pi kiwen walo pi selo pona",
  "block.minecraft.granite_slab": "supa pi kiwen loje",
  "block.minecraft.andesite_slab": "supa pi kiwen pimeja walo",
  "block.minecraft.red_nether_brick_slab": "supa loje pi ma seli",
  "block.minecraft.polished_andesite_slab": "supa pi kiwen pimeja walo pi selo pona",
  "block.minecraft.diorite_slab": "supa pi kiwen walo pimeja",
  "block.minecraft.scaffolding": "supa palisa",
  "block.minecraft.iron_door": "lupa pi kiwen walo",
  "block.minecraft.oak_door": "lupa pi kasi kiwen",
  "block.minecraft.spruce_door": "lupa pi kiwen kasi lete",
  "block.minecraft.birch_door": "lupa pi kiwen kasi walo",
  "block.minecraft.jungle_door": "lupa pi kiwen kasi loje",
  "block.minecraft.acacia_door": "lupa pi kiwen kasi pi loje jelo",
  "block.minecraft.dark_oak_door": "lupa pi kiwen kasi pimeja",
  "block.minecraft.crimson_door": "lupa pi soko loje",
  "block.minecraft.warped_door": "lupa pi soko laso",
  "block.minecraft.repeater": "ilo pi tenpo wawa",
  "block.minecraft.comparator": "ilo pi ante wawa",
  "block.minecraft.structure_block": "ilo tomo",
  "block.minecraft.jigsaw": "leko pi ijo poka",
  "item.minecraft.turtle_helmet": "tomo akesi□□lon lawa la□awen len: +2",
  "item.minecraft.scute": "tomo akesi lili",
  "item.minecraft.iron_shovel": "ilo ma walo□□lon luka lawa la□wawa utala: +3.5□wawa tenpo utala: -3",
  "item.minecraft.iron_pickaxe": "ilo pakala walo□□lon luka lawa la□wawa utala: +3□wawa tenpo utala: -2.8",
  "item.minecraft.iron_axe": "ilo kipisi walo□□lon luka lawa la□wawa utala: +8□wawa tenpo utala: -3.1",
  "item.minecraft.flint_and_steel": "ilo seli",
  "item.minecraft.apple": "kili loje",
  "item.minecraft.bow": "ilo alasa",
  "item.minecraft.arrow": "palisa alasa",
  "item.minecraft.coal": "ko pimeja",
  "item.minecraft.charcoal": "kiwen kasi pi moku seli",
  "item.minecraft.diamond": "kiwen laso",
  "item.minecraft.iron_ingot": "kiwen walo",
  "item.minecraft.gold_ingot": "kiwen jelo",
  "item.minecraft.netherite_ingot": "mani pimeja",
  "item.minecraft.netherite_scrap": "mani pimeja pakala",
  "item.minecraft.iron_sword": "ilo utala walo□□lon luka lawa la□wawa utala: +5□wawa tenpo utala: -2.4",
  "item.minecraft.wooden_sword": "ilo utala kasi□□lon luka lawa la□wawa utala: +3□wawa tenpo utala: -2.4",
  "item.minecraft.wooden_shovel": "ilo ma kasi□□lon luka lawa la□wawa utala: +1.5□wawa tenpo utala: -3",
  "item.minecraft.wooden_pickaxe": "ilo pakala kasi□□lon luka lawa la□wawa utala: +1□wawa tenpo utala: -2.8",
  "item.minecraft.wooden_axe": "ilo kipisi kasi□□lon luka lawa la□wawa utala: +6□wawa tenpo utala: -3.2",
  "item.minecraft.stone_sword": "ilo utala kiwen□□lon luka lawa la□wawa utala: +4□wawa tenpo utala: -2.4",
  "item.minecraft.stone_shovel": "ilo ma kiwen□□lon luka lawa la□wawa utala: +2.5□wawa tenpo utala: -3",
  "item.minecraft.stone_pickaxe": "ilo pakala kiwen□□lon luka lawa la□wawa utala: +2□wawa tenpo utala: -2.8",
  "item.minecraft.stone_axe": "ilo kipisi kiwen□□lon luka lawa la□wawa utala: +8□wawa tenpo utala: -3.2",
  "item.minecraft.diamond_sword": "ilo utala laso□□lon luka lawa la□wawa utala: +6□wawa tenpo utala: -2.4",
  "item.minecraft.diamond_shovel": "ilo ma laso□□lon luka lawa la□wawa utala: +4.5□wawa tenpo utala: -3",
  "item.minecraft.diamond_pickaxe": "ilo pakala laso□□lon luka lawa la□wawa utala: +4□wawa tenpo utala: -2.8",
  "item.minecraft.diamond_axe": "ilo kipisi laso□□lon luka lawa la□wawa utala: +8□wawa tenpo utala: -3",
  "item.minecraft.stick": "palisa",
  "item.minecraft.bowl": "poki moku",
  "item.minecraft.mushroom_stew": "telo moku soko",
  "item.minecraft.golden_sword": "ilo utala jelo□□lon luka lawa la□wawa utala: +3□wawa tenpo utala: -2.4",
  "item.minecraft.golden_shovel": "ilo ma jelo□□lon luka lawa la□wawa utala: +1.5□wawa tenpo utala: -3",
  "item.minecraft.golden_pickaxe": "ilo pakala jelo□□lon luka lawa la□wawa utala: +1□wawa tenpo utala: -2.8",
  "item.minecraft.golden_axe": "ilo kipisi jelo□□lon luka lawa la□wawa utala: +6□wawa tenpo utala: -3",
  "item.minecraft.netherite_sword": "ilo utala pimeja□□lon luka lawa la□wawa utala: +7□wawa tenpo utala: -2.4",
  "item.minecraft.netherite_shovel": "ilo ma pimeja□□lon luka lawa la□wawa utala: +5.5□wawa tenpo utala: -3",
  "item.minecraft.netherite_pickaxe": "ilo pakala pimeja□□lon luka lawa la□wawa utala: +5□wawa tenpo utala: -2.8",
  "item.minecraft.netherite_axe": "ilo kipisi pimeja□□lon luka lawa la□wawa utala: +9□wawa tenpo utala: -3",
  "item.minecraft.string": "linja",
  "item.minecraft.feather": "lipu waso",
  "item.minecraft.gunpowder": "ko pi seli pakala",
  "item.minecraft.wooden_hoe": "ilo kasi tan kasi□□lon luka lawa la□wawa tenpo utala: -3",
  "item.minecraft.stone_hoe": "ilo kasi kiwen□□lon luka lawa la□wawa tenpo utala: -2",
  "item.minecraft.iron_hoe": "ilo kasi walo□□lon luka lawa la□wawa tenpo utala: -1",
  "item.minecraft.diamond_hoe": "ilo kasi laso□□lon luka lawa la",
  "item.minecraft.golden_hoe": "ilo kasi jelo□□lon luka lawa la□wawa tenpo utala: -3",
  "item.minecraft.netherite_hoe": "ilo kasi pimeja□□lon luka lawa la",
  "item.minecraft.wheat_seeds": "sike mama pan",
  "item.minecraft.wheat": "kasi pan",
  "item.minecraft.bread": "pan",
  "item.minecraft.leather_helmet": "len lawa selo□□lon lawa la□awen len: +1",
  "item.minecraft.leather_chestplate": "len sijelo selo□□lon sijelo la□awen len: +3",
  "item.minecraft.leather_leggings": "len noka selo□□lon noka la□awen len: +2",
  "item.minecraft.leather_boots": "len noka anpa selo□□lon noka la:□awen len: +1",
  "item.minecraft.chainmail_helmet": "len lawa pi sike lili□□lon lawa la□awen len: +2",
  "item.minecraft.chainmail_chestplate": "len sijelo pi sike lili□□lon sijelo la□awen len: +5",
  "item.minecraft.chainmail_leggings": "len noka pi sike lili□□lon noka la□awen len: +4",
  "item.minecraft.chainmail_boots": "len noka anpa pi sike lili□□lon noka la:□awen len: +1",
  "item.minecraft.iron_helmet": "len lawa walo□□lon lawa la□awen len: +2",
  "item.minecraft.iron_chestplate": "len sijelo walo□□lon sijelo la□awen len: +6",
  "item.minecraft.iron_leggings": "len noka sewi walo□□lon noka la□awen len: +5",
  "item.minecraft.iron_boots": "len noka anpa walo□□lon noka la:□awen len: +2",
  "item.minecraft.diamond_helmet": "len lawa laso□□lon lawa la□awen len: +3□awen wawa len: +2",
  "item.minecraft.diamond_chestplate": "len sijelo laso□□lon sijelo la□awen len: +8□awen wawa len: +2",
  "item.minecraft.diamond_leggings": "len noka laso□□lon noka la□awen len: +6□awen wawa len: +2",
  "item.minecraft.diamond_boots": "len noka anpa laso□□lon noka la:□awen len: +3□awen wawa len: +2",
  "item.minecraft.golden_helmet": "len lawa jelo□□lon lawa la□awen len: +2",
  "item.minecraft.golden_chestplate": "len sijelo jelo□□lon sijelo la□awen len: +5",
  "item.minecraft.golden_leggings": "len noka jelo□□lon noka la□awen len: +3",
  "item.minecraft.golden_boots": "len noka anpa jelo□□lon noka la:□awen len: +1",
  "item.minecraft.netherite_helmet": "len lawa pimeja□□lon lawa la□awen len: +3□awen wawa len: +3□- tawa tan utala: +1",
  "item.minecraft.netherite_chestplate": "len sijelo pimeja□□lon sijelo la□awen len: +8□awen wawa len: +3□- tawa tan utala: +1",
  "item.minecraft.netherite_leggings": "len noka pimeja□□lon noka la□awen len: +6□awen wawa len: +3□- tawa tan utala: +1",
  "item.minecraft.netherite_boots": "len noka anpa pimeja□□lon noka la:□awen len: +3□awen wawa len: +3□- tawa tan utala: +1",
  "item.minecraft.flint": "kiwen pimeja kipisi",
  "item.minecraft.porkchop": "moku lete pi soweli moku",
  "item.minecraft.cooked_porkchop": "moku seli pi soweli moku",
  "item.minecraft.painting": "sitelen",
  "item.minecraft.golden_apple": "kili mani",
  "item.minecraft.enchanted_golden_apple": "kili mani wawa",
  "block.minecraft.oak_sign": "lipu sitelen pi kasi kiwen",
  "block.minecraft.spruce_sign": "lipu sitelen pi kasi lete",
  "block.minecraft.birch_sign": "lipu sitelen pi kasi walo",
  "block.minecraft.jungle_sign": "lipu sitelen pi kasi loje",
  "block.minecraft.acacia_sign": "lipu sitelen kasi pi loje jelo",
  "block.minecraft.dark_oak_sign": "lipu sitelen pi kasi pimeja",
  "block.minecraft.crimson_sign": "lipu sitelen pi soko loje",
  "block.minecraft.warped_sign": "lipu sitelen pi soko laso",
  "item.minecraft.bucket": "poki telo",
  "item.minecraft.water_bucket": "telo lon poki",
  "item.minecraft.lava_bucket": "telo seli lon poki",
  "item.minecraft.minecart": "poki tawa",
  "item.minecraft.saddle": "len monsi soweli",
  "item.minecraft.redstone": "ko wawa",
  "item.minecraft.snowball": "sike ko lete",
  "item.minecraft.oak_boat": "tomo tawa telo pi kasi kiwen",
  "item.minecraft.leather": "selo soweli",
  "item.minecraft.milk_bucket": "telo walo lon poki",
  "item.minecraft.pufferfish_bucket": "kala pi kama suli lon poki",
  "item.minecraft.salmon_bucket": "kala loje lon poki",
  "item.minecraft.cod_bucket": "kala walo lon poki",
  "item.minecraft.tropical_fish_bucket": "kala kule lon poki",
  "item.minecraft.brick": "leko lili",
  "item.minecraft.clay_ball": "sike pi ma ko",
  "block.minecraft.dried_kelp_block": "kulupu pi kasi telo",
  "item.minecraft.paper": "lipu",
  "item.minecraft.book": "lipu suli",
  "item.minecraft.slime_ball": "ko monsuta",
  "item.minecraft.chest_minecart": "poki tawa poki",
  "item.minecraft.furnace_minecart": "poki tawa seli",
  "item.minecraft.egg": "sike mama waso",
  "item.minecraft.compass": "ilo nasin",
  "item.minecraft.fishing_rod": "ilo kala",
  "item.minecraft.clock": "ilo tenpo",
  "item.minecraft.glowstone_dust": "ko suno",
  "item.minecraft.cod": "kala walo lete",
  "item.minecraft.salmon": "kala loje lete",
  "item.minecraft.tropical_fish": "kala kule",
  "item.minecraft.pufferfish": "kala pi kama suli",
  "item.minecraft.cooked_cod": "moku seli pi kala walo",
  "item.minecraft.cooked_salmon": "moku seli pi kala loje",
  "item.minecraft.ink_sac": "telo pimeja",
  "item.minecraft.red_dye": "kule loje",
  "item.minecraft.green_dye": "kule kasi",
  "item.minecraft.cocoa_beans": "kili pi kule ma",
  "item.minecraft.lapis_lazuli": "kiwen pi laso telo",
  "item.minecraft.purple_dye": "kule pi laso loje",
  "item.minecraft.cyan_dye": "kule laso",
  "item.minecraft.light_gray_dye": "kule pi walo pimeja",
  "item.minecraft.gray_dye": "kule pi pimeja walo",
  "item.minecraft.pink_dye": "kule pi loje walo",
  "item.minecraft.lime_dye": "kule pi laso jelo",
  "item.minecraft.yellow_dye": "kule jelo",
  "item.minecraft.light_blue_dye": "kule pi laso sewi",
  "item.minecraft.magenta_dye": "kule pi loje laso",
  "item.minecraft.orange_dye": "kule pi loje jelo",
  "item.minecraft.bone_meal": "ko pi palisa sijelo",
  "item.minecraft.blue_dye": "kule pi laso telo",
  "item.minecraft.brown_dye": "kule ma",
  "item.minecraft.black_dye": "kule pimeja",
  "item.minecraft.white_dye": "kule walo",
  "item.minecraft.bone": "palisa sijelo",
  "item.minecraft.sugar": "ko suwi",
  "block.minecraft.cake": "pan suwi",
  "block.minecraft.white_bed": "supa lape walo",
  "block.minecraft.orange_bed": "supa lape pi loje jelo",
  "block.minecraft.magenta_bed": "supa lape pi loje laso",
  "block.minecraft.light_blue_bed": "supa lape pi laso sewi",
  "block.minecraft.yellow_bed": "supa lape jelo",
  "block.minecraft.lime_bed": "supa lape pi laso jelo",
  "block.minecraft.pink_bed": "supa lape pi loje walo",
  "block.minecraft.gray_bed": "supa lape pi pimeja walo",
  "block.minecraft.light_gray_bed": "supa lape pi walo pimeja",
  "block.minecraft.cyan_bed": "supa lape laso",
  "block.minecraft.purple_bed": "supa lape loje laso",
  "block.minecraft.blue_bed": "supa lape pi laso telo",
  "block.minecraft.brown_bed": "supa lape pi kule ma",
  "block.minecraft.green_bed": "supa lape pi laso kasi",
  "block.minecraft.red_bed": "supa lape loje",
  "block.minecraft.black_bed": "supa lape pimeja",
  "item.minecraft.cookie": "pan sike suwi",
  "item.minecraft.filled_map": "sitelen ma□#0",
  "item.minecraft.shears": "ilo kipisi lili",
  "item.minecraft.melon_slice": "kipisi pi kili suli laso",
  "item.minecraft.dried_kelp": "kasi telo seli",
  "item.minecraft.pumpkin_seeds": "sike mama pi kili suli jelo",
  "item.minecraft.melon_seeds": "sike mama pi kili suli laso",
  "item.minecraft.beef": "moku mani lete",
  "item.minecraft.cooked_beef": "moku mani seli",
  "item.minecraft.chicken": "moku waso lete",
  "item.minecraft.cooked_chicken": "moku waso seli",
  "item.minecraft.rotten_flesh": "sijelo jaki",
  "item.minecraft.ender_pearl": "sike pi ma pini",
  "item.minecraft.blaze_rod": "palisa seli",
  "item.minecraft.ghast_tear": "telo oko pi monsuta kon",
  "item.minecraft.gold_nugget": "kiwen jelo lili",
  "item.minecraft.nether_wart": "soko wawa",
  "item.minecraft.potion": "telo pi ken ala pali□wawa ala",
  "item.minecraft.glass_bottle": "poki lili",
  "item.minecraft.spider_eye": "oko pipi",
  "item.minecraft.fermented_spider_eye": "oko pipi nasa",
  "item.minecraft.blaze_powder": "ko pi palisa seli",
  "item.minecraft.magma_cream": "ko monsuta seli",
  "block.minecraft.brewing_stand": "ilo pi telo wawa",
  "block.minecraft.cauldron": "poki suli",
  "item.minecraft.ender_eye": "oko pi ma pini",
  "item.minecraft.glistering_melon_slice": "kipisi kili mani",
  "item.minecraft.bat_spawn_egg": "sike mama pi waso pimeja",
  "item.minecraft.bee_spawn_egg": "sike mama pi pipi suwi",
  "item.minecraft.blaze_spawn_egg": "sike mama pi monsuta seli",
  "item.minecraft.cat_spawn_egg": "sike mama pi soweli suwi",
  "item.minecraft.cave_spider_spawn_egg": "sike mama pi pipi lupa",
  "item.minecraft.chicken_spawn_egg": "sike mama pi waso nasa",
  "item.minecraft.cod_spawn_egg": "sike mama pi kala walo",
  "item.minecraft.cow_spawn_egg": "sike mama mani",
  "item.minecraft.creeper_spawn_egg": "sike mama pi monsuta pakala",
  "item.minecraft.dolphin_spawn_egg": "sike mama pi kala suli",
  "item.minecraft.donkey_spawn_egg": "sike mama pi soweli jo",
  "item.minecraft.drowned_spawn_egg": "sike mama pi jan moli telo",
  "item.minecraft.elder_guardian_spawn_egg": "sike mama pi kala oko suli",
  "item.minecraft.enderman_spawn_egg": "sike mama pi jan pi ma pini",
  "item.minecraft.endermite_spawn_egg": "sike mama pi pipi nasa",
  "item.minecraft.evoker_spawn_egg": "sike mama pi jan ike wawa",
  "item.minecraft.fox_spawn_egg": "sike mama pi soweli pi linja monsi",
  "item.minecraft.ghast_spawn_egg": "sike mama pi monsuta kon",
  "item.minecraft.guardian_spawn_egg": "sike mama pi kala oko",
  "item.minecraft.hoglin_spawn_egg": "sike mama pi soweli monsuta",
  "item.minecraft.horse_spawn_egg": "sike mama pi soweli tawa",
  "item.minecraft.husk_spawn_egg": "sike mama pi jan moli seli",
  "item.minecraft.llama_spawn_egg": "sike mama pi soweli pi telo uta",
  "item.minecraft.magma_cube_spawn_egg": "sike mama pi monsuta ko seli",
  "item.minecraft.mooshroom_spawn_egg": "sike mama pi mani soko",
  "item.minecraft.mule_spawn_egg": "sike mama pi soweli jo tawa",
  "item.minecraft.ocelot_spawn_egg": "sike mama pi soweli alasa",
  "item.minecraft.panda_spawn_egg": "sike mama pi soweli pimeja walo",
  "item.minecraft.parrot_spawn_egg": "sike mama pi waso toki",
  "item.minecraft.phantom_spawn_egg": "sike mama pi waso mun",
  "item.minecraft.pig_spawn_egg": "sike mama pi soweli moku",
  "item.minecraft.piglin_spawn_egg": "sike mama pi jan soweli",
  "item.minecraft.pillager_spawn_egg": "sike mama pi jan ike alasa",
  "item.minecraft.polar_bear_spawn_egg": "sike mama pi soweli lete",
  "item.minecraft.pufferfish_spawn_egg": "sike mama pi kala pi kama suli",
  "item.minecraft.rabbit_spawn_egg": "sike mama pi soweli lili",
  "item.minecraft.ravager_spawn_egg": "sike mama pi monsuta suli",
  "item.minecraft.salmon_spawn_egg": "sike mama pi kala loje",
  "item.minecraft.sheep_spawn_egg": "sike mama pi soweli len",
  "item.minecraft.shulker_spawn_egg": "sike mama pi monsuta poki",
  "item.minecraft.silverfish_spawn_egg": "sike mama pi pipi kiwen",
  "item.minecraft.skeleton_spawn_egg": "sike mama pi jan moli palisa",
  "item.minecraft.skeleton_horse_spawn_egg": "sike mama pi soweli tawa palisa",
  "item.minecraft.slime_spawn_egg": "sike mama pi monsuta ko",
  "item.minecraft.spider_spawn_egg": "sike mama pi pipi noka",
  "item.minecraft.squid_spawn_egg": "sike mama pi kala luka",
  "item.minecraft.stray_spawn_egg": "sike mama pi jan moli lete",
  "item.minecraft.strider_spawn_egg": "sike mama pi akesi seli",
  "item.minecraft.trader_llama_spawn_egg": "sike mama pi soweli pi jan esun",
  "item.minecraft.tropical_fish_spawn_egg": "sike mama pi kala kule",
  "item.minecraft.turtle_spawn_egg": "sike mama pi akesi tomo",
  "item.minecraft.vex_spawn_egg": "sike mama pi jan kon",
  "item.minecraft.villager_spawn_egg": "sike mama pi jan tomo",
  "item.minecraft.vindicator_spawn_egg": "sike mama pi jan ike kipisi",
  "item.minecraft.wandering_trader_spawn_egg": "sike mama pi jan esun",
  "item.minecraft.witch_spawn_egg": "sike mama pi jan pi telo wawa",
  "item.minecraft.wither_skeleton_spawn_egg": "sike mama pi jan moli pimeja",
  "item.minecraft.wolf_spawn_egg": "sike mama pi soweli pona",
  "item.minecraft.zoglin_spawn_egg": "sike mama pi soweli monsuta moli",
  "item.minecraft.zombie_spawn_egg": "sike mama pi jan moli",
  "item.minecraft.zombie_horse_spawn_egg": "sike mama pi soweli tawa moli",
  "item.minecraft.zombie_villager_spawn_egg": "sike mama pi jan tomo moli",
  "item.minecraft.zombified_piglin_spawn_egg": "sike mama pi jan soweli moli",
  "item.minecraft.experience_bottle": "wawa sona lon poki",
  "item.minecraft.fire_charge": "sike seli",
  "item.minecraft.writable_book": "lipu en ilo sitelen",
  "item.minecraft.written_book": "lipu sitelen",
  "item.minecraft.emerald": "kiwen esun",
  "item.minecraft.item_frame": "lipu poki",
  "block.minecraft.flower_pot": "poki kasi",
  "item.minecraft.carrot": "kili palisa",
  "item.minecraft.potato": "kili ma",
  "item.minecraft.baked_potato": "kili ma seli",
  "item.minecraft.poisonous_potato": "kili ma jaki",
  "item.minecraft.map": "sitelen ma weka",
  "item.minecraft.golden_carrot": "kili palisa mani",
  "block.minecraft.skeleton_skull": "lawa pi jan moli palisa",
  "block.minecraft.wither_skeleton_skull": "lawa pi jan moli pimeja",
  "block.minecraft.player_head": "lawa jan",
  "block.minecraft.zombie_head": "lawa pi jan moli",
  "block.minecraft.creeper_head": "lawa pi monsuta pakala",
  "block.minecraft.dragon_head": "lawa pi akesi pini",
  "item.minecraft.carrot_on_a_stick": "kili palisa lon palisa",
  "item.minecraft.warped_fungus_on_a_stick": "soko lon palisa",
  "item.minecraft.nether_star": "mun pi ma seli",
  "item.minecraft.pumpkin_pie": "pan suwi pi kili suli jelo",
  "item.minecraft.firework_rocket": "palisa pi seli kule",
  "item.minecraft.firework_star": "sike pi seli kule",
  "item.minecraft.enchanted_book": "lipu wawa",
  "item.minecraft.nether_brick": "leko lili pi ma seli",
  "item.minecraft.quartz": "kiwen walo pi ma seli",
  "item.minecraft.tnt_minecart": "poki tawa pi seli pakala",
  "item.minecraft.hopper_minecart": "poki tawa pi tawa ijo",
  "item.minecraft.prismarine_shard": "kipisi pi kiwen telo",
  "item.minecraft.prismarine_crystals": "kipisi pi kiwen telo suno",
  "item.minecraft.rabbit": "moku lete pi soweli lili",
  "item.minecraft.cooked_rabbit": "moku seli pi soweli lili",
  "item.minecraft.rabbit_stew": "telo moku pi soweli lili",
  "item.minecraft.rabbit_foot": "noka pi soweli lili",
  "item.minecraft.rabbit_hide": "selo pi soweli lili",
  "item.minecraft.armor_stand": "ilo jo len",
  "item.minecraft.iron_horse_armor": "len soweli walo",
  "item.minecraft.golden_horse_armor": "len soweli jelo",
  "item.minecraft.diamond_horse_armor": "len soweli laso",
  "item.minecraft.leather_horse_armor": "len soweli selo",
  "item.minecraft.lead": "linja lawa",
  "item.minecraft.name_tag": "lipu nimi",
  "item.minecraft.command_block_minecart": "poki tawa pi toki wawa",
  "item.minecraft.mutton": "moku lete pi soweli len",
  "item.minecraft.cooked_mutton": "moku seli pi soweli len",
  "block.minecraft.white_banner": "len sitelen walo",
  "block.minecraft.orange_banner": "len sitelen pi loje jelo",
  "block.minecraft.magenta_banner": "len sitelen pi loje laso",
  "block.minecraft.light_blue_banner": "len sitelen pi laso sewi",
  "block.minecraft.yellow_banner": "len sitelen jelo",
  "block.minecraft.lime_banner": "len sitelen pi laso jelo",
  "block.minecraft.pink_banner": "len sitelen pi loje walo",
  "block.minecraft.gray_banner": "len sitelen pi pimeja walo",
  "block.minecraft.light_gray_banner": "len sitelen pi walo pimeja",
  "block.minecraft.cyan_banner": "len sitelen laso",
  "block.minecraft.purple_banner": "len sitelen pi laso loje",
  "block.minecraft.blue_banner": "len sitelen pi laso telo",
  "block.minecraft.brown_banner": "len sitelen pi kule ma",
  "block.minecraft.green_banner": "len sitelen pi laso kasi",
  "block.minecraft.red_banner": "len sitelen loje",
  "block.minecraft.black_banner": "len sitelen pimeja",
  "item.minecraft.end_crystal": "ilo wawa pi ma pini",
  "item.minecraft.chorus_fruit": "kili nasa",
  "item.minecraft.popped_chorus_fruit": "kili nasa seli",
  "item.minecraft.beetroot": "kili ma loje",
  "item.minecraft.beetroot_seeds": "sike mama pi kili ma loje",
  "item.minecraft.beetroot_soup": "telo moku pi kili ma loje",
  "item.minecraft.dragon_breath": "kon pi akesi pini",
  "item.minecraft.splash_potion": "telo wawa pana pi ken ala pali□wawa ala",
  "item.minecraft.spectral_arrow": "palisa alasa suno",
  "item.minecraft.tipped_arrow": "palisa alasa wawa pi ken ala pali□wawa ala",
  "item.minecraft.lingering_potion": "kon wawa pi ken ala pali□wawa ala",
  "item.minecraft.shield": "sinpin sijelo",
  "item.minecraft.elytra": "luka waso",
  "item.minecraft.spruce_boat": "tomo tawa telo pi kasi lete",
  "item.minecraft.birch_boat": "tomo tawa telo walo",
  "item.minecraft.jungle_boat": "tomo tawa telo loje",
  "item.minecraft.acacia_boat": "tomo tawa telo pi loje jelo",
  "item.minecraft.dark_oak_boat": "tomo tawa telo pimeja",
  "item.minecraft.totem_of_undying": "ilo pi moli ala",
  "item.minecraft.shulker_shell": "selo pi monsuta poki",
  "item.minecraft.iron_nugget": "kiwen walo lili",
  "item.minecraft.knowledge_book": "lipu pi sona pali",
  "item.minecraft.debug_stick": "palisa wawa",
  "item.minecraft.music_disc_13": "sike kalama□jan c418 - nanpa ike",
  "item.minecraft.music_disc_cat": "sike kalama□jan c418 - soweli",
  "item.minecraft.music_disc_blocks": "sike kalama□jan c418 - leko",
  "item.minecraft.music_disc_chirp": "sike kalama□jan c418 - mu",
  "item.minecraft.music_disc_far": "sike kalama□jan c418 - weka",
  "item.minecraft.music_disc_mall": "sike kalama□jan c418 - esun",
  "item.minecraft.music_disc_mellohi": "sike kalama□jan c418 - melosi",
  "item.minecraft.music_disc_stal": "sike kalama□jan c418 - tala",
  "item.minecraft.music_disc_strad": "sike kalama□jan c418 - linja",
  "item.minecraft.music_disc_ward": "sike kalama□jan c418 - sinpin",
  "item.minecraft.music_disc_11": "sike kalama□jan c418 - luka luka wan",
  "item.minecraft.music_disc_wait": "sike kalama□jan c418 - awen",
  "item.minecraft.music_disc_pigstep": "sike kalama□jan lina wen - pigstep",
  "item.minecraft.trident": "ilo alasa telo□□lon luka lawa la□wawa utala: +8□wawa tenpo utala: -2.9",
  "item.minecraft.phantom_membrane": "selo pi waso mun",
  "item.minecraft.nautilus_shell": "tomo kala",
  "item.minecraft.heart_of_the_sea": "pilin pi telo suli",
  "item.minecraft.crossbow": "ilo alasa supa",
  "item.minecraft.suspicious_stew": "telo moku nasa",
  "block.minecraft.loom": "ilo len",
  "item.minecraft.flower_banner_pattern": "ilo sitelen□kasi kule",
  "item.minecraft.creeper_banner_pattern": "ilo sitelen□sinpin pi monsuta pakala",
  "item.minecraft.skull_banner_pattern": "ilo sitelen□sinpin pi jan moli palisa",
  "item.minecraft.mojang_banner_pattern": "ilo sitelen□ijo",
  "item.minecraft.globe_banner_pattern": "ilo sitelen□sike pi ma ale",
  "item.minecraft.piglin_banner_pattern": "ilo sitelen□nena soweli",
  "block.minecraft.composter": "poki jaki",
  "block.minecraft.barrel": "poki sike",
  "block.minecraft.smoker": "poki pi seli moku",
  "block.minecraft.blast_furnace": "poki pi seli kiwen",
  "block.minecraft.cartography_table": "supa pi sitelen ma",
  "block.minecraft.fletching_table": "supa pi palisa alasa",
  "block.minecraft.grindstone": "sike pi pona ilo",
  "block.minecraft.lectern": "supa lipu",
  "block.minecraft.smithing_table": "supa ilo",
  "block.minecraft.stonecutter": "sike pi kipisi kiwen",
  "block.minecraft.bell": "ilo kalama jelo",
  "block.minecraft.lantern": "suno",
  "block.minecraft.soul_lantern": "suno kon",
  "item.minecraft.sweet_berries": "kili suwi",
  "block.minecraft.campfire": "seli palisa",
  "block.minecraft.soul_campfire": "seli palisa kon",
  "block.minecraft.shroomlight": "suno soko",
  "item.minecraft.honeycomb": "lipu suwi",
  "block.minecraft.bee_nest": "tomo pi pipi suwi",
  "block.minecraft.beehive": "tomo pali pi pipi suwi",
  "item.minecraft.honey_bottle": "telo suwi lon poki",
  "block.minecraft.honey_block": "telo suwi suli",
  "block.minecraft.honeycomb_block": "lipu suwi suli",
  "block.minecraft.lodestone": "kiwen nasin",
  "block.minecraft.netherite_block": "leko pi mani pimeja",
  "block.minecraft.ancient_debris": "pakala mani",
  "block.minecraft.target": "sike pi alasa musi",
  "block.minecraft.crying_obsidian": "kiwen wawa pakala",
  "block.minecraft.blackstone": "kiwen pimeja",
  "block.minecraft.blackstone_slab": "supa kiwen pimeja",
  "block.minecraft.blackstone_stairs": "leko sewi pi kiwen pimeja",
  "block.minecraft.gilded_blackstone": "kiwen pimeja mani",
  "block.minecraft.polished_blackstone": "kiwen pimeja pi selo pona",
  "block.minecraft.polished_blackstone_slab": "supa pi kiwen pimeja pi selo pona",
  "block.minecraft.polished_blackstone_stairs": "leko sewi pi kiwen pimeja pi selo pona",
  "block.minecraft.chiseled_polished_blackstone": "kiwen pimeja sitelen",
  "block.minecraft.polished_blackstone_bricks": "kiwen pimeja leko",
  "block.minecraft.polished_blackstone_brick_slab": "supa pi kiwen pimeja leko",
  "block.minecraft.polished_blackstone_brick_stairs": "leko sewi pi kiwen pimeja leko",
  "block.minecraft.cracked_polished_blackstone_bricks": "kiwen pimeja leko pakala",
  "block.minecraft.respawn_anchor": "ilo pi kama sin",
}
export const tok = items; 
